export default __webpack_public_path__ + "static/media/internRed.483f0df2.svg";